export default {
  placeholder: 'Szukaj firmy...',
};
